const TGEN_POOL_ADDRESS = "0xb6d72ccd34928314228fa72a8e80800dd9907795";

export const TGEN_POOL_PAGE_URL =
  `https://www.geckoterminal.com/bsc/pools/${TGEN_POOL_ADDRESS}`;

export const TGEN_POOL_API_URL =
  `https://api.geckoterminal.com/api/v2/networks/bsc/pools/${TGEN_POOL_ADDRESS}`;

const TGEN_POOL_FALLBACK_API_URL =
  `https://api.dexscreener.com/latest/dex/pairs/bsc/${TGEN_POOL_ADDRESS}`;

function toNum(val) {
  const n = Number(val);
  return Number.isFinite(n) ? n : null;
}

function normalizeResult(raw = {}) {
  const priceUsd = toNum(raw.priceUsd);
  const change24h = toNum(raw.change24h);
  const marketCap = toNum(raw.marketCap);
  const fdv = toNum(raw.fdv);

  return { priceUsd, change24h, marketCap, fdv };
}

function parseGeckoPoolPayload(json) {
  const attrs = json?.data?.attributes || {};
  return normalizeResult({
    priceUsd: attrs.base_token_price_usd ?? attrs.price_usd ?? attrs.token_price_usd,
    change24h: attrs?.price_change_percentage?.h24 ?? attrs?.price_change_24h,
    marketCap: attrs.market_cap_usd ?? attrs.market_cap,
    fdv: attrs.fdv_usd ?? attrs.fdv,
  });
}

function parseDexScreenerFallbackPayload(json) {
  const pair = json?.pair || {};
  return normalizeResult({
    priceUsd: pair.priceUsd,
    change24h: pair?.priceChange?.h24,
    marketCap: pair.marketCap,
    fdv: pair.fdv,
  });
}

export async function fetchTgenPoolData() {
  try {
    const res = await fetch(TGEN_POOL_API_URL, {
      headers: { Accept: "application/json" },
    });

    if (!res.ok) {
      throw new Error(`GeckoTerminal API failed: ${res.status}`);
    }

    const json = await res.json();
    const parsed = parseGeckoPoolPayload(json);

    // If API shape changes or empty payload returns nulls, trigger fallback.
    if (parsed.priceUsd == null) {
      throw new Error("GeckoTerminal payload missing price");
    }

    return parsed;
  } catch {
    const fallbackRes = await fetch(TGEN_POOL_FALLBACK_API_URL, {
      headers: { Accept: "application/json" },
    });
    if (!fallbackRes.ok) {
      throw new Error(`Pool fallback API failed: ${fallbackRes.status}`);
    }
    const fallbackJson = await fallbackRes.json();
    const parsedFallback = parseDexScreenerFallbackPayload(fallbackJson);
    if (parsedFallback.priceUsd == null) {
      throw new Error("Pool fallback payload missing price");
    }
    return parsedFallback;
  }
}
